module.exports = __webpack_public_path__ + "img/logo1.c19f5339.png";